import axios from 'axios';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const token = document.head.querySelector('meta[name="csrf-token"]');

/**
 * Attach CSRF token to request headers
 * @param {HTMLMetaElement | null} token
 */
if (token) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}

/**
 * Catch unauthorised responses and subsequently log the user out
 */
axios.interceptors.response.use(
  undefined,
  (error) => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/logout';
    }
    return Promise.reject(error);
  },
);

export default axios;
